import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserDataContext } from '../context/UserContext';
import '../components/Login.css';
import axios from 'axios';

function CollectorLogin() {
    const navigate = useNavigate();
    const { setUser } = useContext(UserDataContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Basic validation
        if (!username.trim()) {
            setError('Please enter your mobile number');
            setLoading(false);
            return;
        }

        if (!password.trim()) {
            setError('Please enter your password');
            setLoading(false);
            return;
        }

        // Validate mobile number format (10 digits)
        if (!/^\d{10}$/.test(username.trim())) {
            setError('Please enter a valid 10-digit mobile number');
            setLoading(false);
            return;
        }

        if (password.length < 6) {
            setError('Please enter a valid password');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/collectors/login`, {
                "mobile_no": username.trim(),
                "password": password.trim()
            });

            const data = await response.data;

            if (!response.data.success) {
                throw new Error(data.message || 'Login failed. Please check your credentials.');
            }

            // Check if access_token exists in response
            if (data.data.access_token) {
                // Store JWT token in localStorage
                localStorage.setItem('access_token', data.data.access_token);

                // Store complete user data in localStorage
                const backendUserData = data.data.collector || data.data.user || {};
                const userData = {
                    collectorsId: backendUserData.collectorsId,
                    name: backendUserData.name,
                    username: backendUserData.username,
                    employee_id: backendUserData.employee_id,
                    mobile_no: backendUserData.mobile_no,
                    active_duty_id: backendUserData.active_duty_id || null,
                    role: 'COLLECTOR',
                    authenticated: true
                };
                localStorage.setItem('collectors_data', JSON.stringify(userData));

                // Update context
                setUser(userData);

                // Navigate to home after successful login
                navigate('/collectors-home');
            } else {
                throw new Error('No access token received from server');
            }
        } catch (err) {
            setError(err.message || 'An error occurred during login. Please try again.');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="login-title" style={{ color: 'rgba(29, 87, 12, 1)' }}>Collector Login</h2>
                <form onSubmit={handleSubmit} className="login-form">
                    {error && <div className="error-message">{error}</div>}

                    <div className="form-group">
                        <label htmlFor="username">Mobile Number</label>
                        <input
                            type="tel"
                            id="username"
                            value={username}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Only allow digits and limit to 10 characters
                                if (/^\d*$/.test(value) && value.length <= 10) {
                                    setUsername(value);
                                }
                            }}
                            placeholder="Enter your mobile number"
                            className="form-input"
                            maxLength={10}
                            pattern="\d{10}"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                className="form-input"
                                style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px' }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22" /></svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? 'Signing In...' : 'Sign In'}
                    </button>
                    <div style={{ marginTop: '15px', textAlign: 'center' }}>
                        <Link to="/login" style={{ textDecoration: 'none', color: '#007bff' }}>Login as Admin</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CollectorLogin;
